<template>
  <div>


    <div class="col-md-12">

      <div class="mb-1 d-flex w-100 justify-content-between">
        <span class="text-blue me-1">{{ material.activitat_titol }}</span>
      </div>

      <div v-if="material.activitat_subtipus_innovacio" class="text-upc-green fw-bolder mb-1">{{$t(material.activitat_subtipus_innovacio)}}</div>

      <div class="text-secondary mb-1" v-if="material.activitat_professors">
        <i class="fa-solid fa-user text-secondary fa-xs me-1"></i>
        <span v-for="(professor, index) in material.activitat_professors" v-bind:key="professor">
          {{professor.split('##')[0]}}<span v-if="index !== (material.activitat_professors.length-1)" class="me-1">;</span>
        </span>
      </div>

      <div v-if="material.activitat_resum" class="mt-3">
        <button v-if="material.activitat_resum" @click.prevent='hideShow("resum"+index)' style="cursor:pointer; display: inline-block;" class="nav-link text-secondary me-4"><i class="fa-solid fa-search text-blue"></i> {{$t('Veure detall')}} </button>
        <div v-bind:id="'resum'+index" class="alert alert-dark mt-3" style="display: none;">
          <div v-for="(resum, index) in material.activitat_resum" v-bind:key="resum">
            <div v-if="index !== (material.activitat_resum.length-1)" class="mb-4">{{resum}}</div>
            <div v-else>{{resum}}</div>
          </div>
        </div>
      </div>

    </div>


  </div>
</template>


<script>

import {imageUrlAlt} from "@/utils/utils";

export default {

  name: "ItemListInnovacio",
  methods: {imageUrlAlt},
  props: {
    material: Object,
    index: Number
  },
  setup() {

    const hideShow = (index) => {
      const element = document.getElementById(index);
      if (element) {
        if (element.style.display === 'none') {
          element.style.display = 'block';
        } else {
          element.style.display = 'none';
        }
      }
    };

    return {
      hideShow

    }
  }
}
</script>

<style scoped>
button:hover {
  text-decoration: underline;
}
</style>
